const LAZY_LOAD_CHUNK_NAME = path => () =>
  import(
    /* webpackChunkName: "human-resources" */ `@/views/humanResources/${path}`
  );

export default [
  {
    path: "humanres",
    name: "humanResources-menu",
    component: () => import("@/views/HumanResources.vue"),
    children: [
      {
        path: "/humanres",
        name: "humanres",
        component: LAZY_LOAD_CHUNK_NAME("Menu"),
        meta: { IsParent: true }
      },
      {
        path: "/humanres/request",
        name: "humanResources",
        component: LAZY_LOAD_CHUNK_NAME("request/Wrapper"),
        children: [
          {
            path: "",
            name: "humanResources",
            component: LAZY_LOAD_CHUNK_NAME("request/Main")
          },
          {
            path: "/humanres/request/add",
            name: "AddRequestPersonalStaff",
            component: LAZY_LOAD_CHUNK_NAME(
              "request/AddEditReadRequestPersonalStaff"
            )
          },
          {
            path: "/humanres/request/edit/:id",
            name: "EditRequestPersonalStaff",
            component: LAZY_LOAD_CHUNK_NAME(
              "request/AddEditReadRequestPersonalStaff"
            )
          },
          {
            path: "/humanres/irregularrequest/edit/:id",
            name: "EditIrregularRequestPersonalStaff",
            props: true,
            component: LAZY_LOAD_CHUNK_NAME(
              "request/AddEditReadRequestPersonalStaff"
            )
          },
          {
            path: "/humanres/irregularrequest/edit/:requestId/provremedyreq/:studentSieId/add/",
            name: "AddProvRemedyReq",
            component: LAZY_LOAD_CHUNK_NAME(
              "request/AddProvRemRequest"
            )
          },
          {
            path: "/humanres/request/history/:id",
            name: "RequestHistory",
            component: LAZY_LOAD_CHUNK_NAME("request/History")
          },
          {
            path: "/humanres/request/resume/:id",
            name: "RequestResume",
            component: LAZY_LOAD_CHUNK_NAME("irregularStaffRequest/ResumeRequests")
          },
          {
            path: "/humanres/irregularrequest/saee10history/:id",
            name: "Saee10History",
            component: LAZY_LOAD_CHUNK_NAME("irregularStaffRequest/Saee10History")
          }
        ]
      },
      {
        path: "/humanres/serviceassistantmanagement",
        name: "ServiceAssistant",
        component: LAZY_LOAD_CHUNK_NAME("serviceAssistant/Wrapper"),
        children: [
          {
            path: "",
            name: "ServiceAssistant",
            component: LAZY_LOAD_CHUNK_NAME("serviceAssistant/Main")
          },
          {
            path:
              "/humanres/serviceAssistantManagement/manage/:schoolId-:academicYearId",
            name: "ManageServiceAssistant",
            component: LAZY_LOAD_CHUNK_NAME("serviceAssistant/Manage"),
            props: ({ params }) => ({
              schoolId: +params.schoolId || 0,
              academicYearId: +params.academicYearId || 0
            })
          }
        ]
      },
      {
        path: "/humanres/locationalternativemanagement",
        name: "locationAlternativeManagement",
        component: LAZY_LOAD_CHUNK_NAME(
          "locationAlternativeManagement/Wrapper"
        ),
        children: [
          {
            path: "",
            name: "locationAlternativeManagement",
            component: LAZY_LOAD_CHUNK_NAME(
              "locationAlternativeManagement/Main"
            )
          },
          {
            path: ":id",
            name: "Management",
            component: LAZY_LOAD_CHUNK_NAME(
              "locationAlternativeManagement/Management"
            )
          },
          {
            path: "otherschoolenrollment",
            name: "OtherSchoolEnrollment",
            component: LAZY_LOAD_CHUNK_NAME(
              "locationAlternativeManagement/OtherSchoolEnrollment"
            )
          }
        ]
      },
      {
        path: "/humanres/irregularstaffrequest",
        name: "irregularStaffRequest",
        component: LAZY_LOAD_CHUNK_NAME("irregularStaffRequest/Wrapper"),
        children: [
          {
            path: "",
            name: "irregularStaffRequest",
            component: LAZY_LOAD_CHUNK_NAME("irregularStaffRequest/Main")
          },
          {
            path: "/humanres/irregularstaffrequest/saee10/:id",
            name: "irregularStaffNecessitiesReview",
            component: LAZY_LOAD_CHUNK_NAME("irregularStaffRequest/NecessitiesReview")
          },
          {
            path: '/humanres/irregularstaffrequest/addstaff',
            name: 'irregularStaffRequestRequestResource',
            component: LAZY_LOAD_CHUNK_NAME('irregularStaffRequest/requestResource/Create'),
          },
          {
            path: '/humanres/irregularstaffrequest/:id',
            name: 'editIrregularStaffRequestRequestResource',
            component: LAZY_LOAD_CHUNK_NAME('irregularStaffRequest/requestResource/Edit'),
          },
        ]
      },
    ]
  }
];
